export default {
  96: [
    {
      label: 'Opsi 1',
      value: 1,
      deskripsi:
        'Kepala sekolah memahami bahwa penting untuk mengembangkan kelas sebagai sistem sosial yang mewujudkan merdeka belajar.',
    },
    {
      label: 'Opsi 2',
      value: 2,
      deskripsi:
        'Kepala sekolah mengajak guru untuk mengembangkan kelas sebagai sistem sosial yang mewujudkan merdeka belajar.',
    },
    {
      label: 'Opsi 3',
      value: 3,
      deskripsi:
        'Kepala sekolah melibatkan seluruh warga sekolah untuk berpartisipasi dalam mewujudkan lingkungan belajar yang aman dan nyaman bagi aktivitas murid dan guru sehingga senantiasa terwujud merdeka belajar.',
    },
    {
      label: 'Opsi 4',
      value: 4,
      deskripsi:
        'Kepala sekolah memastikan dan membangun komunikasi serta interaksi persuasif seluruh warga sekolah dalam berpartisipasi mewujudkan lingkungan sekolah yang kondusif, aman, dan nyaman bagi aktivitas murid dan guru sehingga senantiasa terwujud merdeka belajar.',
    },
    {
      label: 'Opsi 5',
      value: 5,
      deskripsi:
        'Kepala sekolah mengembangkan sistem yang memastikan masukan dan aspirasi murid sebagai pertimbangan dalam penyusunan kebijakan dan praktik belajar pada level kelas dan sekolah dengan dukungan dari warga sekolah yang lain untuk mewujudkan lingkungan belajar yang kondusif, aman, dan nyaman bagi aktivitas murid dan guru sehingga sehingga senantiasa terwujud merdeka belajar.',
    },
  ],
  97: [
    {
      label: 'Opsi 1',
      value: 1,
      deskripsi: 'Kepala sekolah memimpin pertemuan refleksi yang melibatkan guru namun belum secara berkala.',
    },
    {
      label: 'Opsi 2',
      value: 2,
      deskripsi:
        'Kepala sekolah memimpin pertemuan refleksi secara berkala yang melibatkan semua guru untuk perbaikan kualitas proses belajar.  ',
    },
    {
      label: 'Opsi 3',
      value: 3,
      deskripsi:
        'Kepala sekolah memimpin pertemuan refleksi secara berkala yang melibatkan semua guru berdasarkan analisis data yang menghasilkan inisiatif untuk perbaikan kualitas proses belajar yang terukur.',
    },
    {
      label: 'Opsi 4',
      value: 4,
      deskripsi:
        'Kepala sekolah memimpin pertemuan refleksi secara berkala yang melibatkan semua guru berdasarkan analisis data yang menghasilkan inisiatif kolaboratif untuk perbaikan kualitas proses belajar yang terukur.',
    },
    {
      label: 'Opsi 5',
      value: 5,
      deskripsi:
        'Kepala sekolah mengembangkan mekanisme refleksi secara berkala yang melibatkan semua guru berdasarkan analisis data yang menghasilkan inisiatif kolaboratif untuk perbaikan kualitas proses belajar yang terukur.',
    },
  ],
  98: [
    {
      label: 'Opsi 1',
      value: 1,
      deskripsi:
        'Kepala sekolah memahami bahwa penting untuk mengembangkan kelas sebagai sistem sosial yang mewujudkan merdeka belajar.',
    },
    {
      label: 'Opsi 2',
      value: 2,
      deskripsi:
        'Kepala sekolah mengajak guru untuk mengembangkan kelas sebagai sistem sosial yang mewujudkan merdeka belajar.',
    },
    {
      label: 'Opsi 3',
      value: 3,
      deskripsi:
        'Kepala sekolah melibatkan seluruh warga sekolah untuk berpartisipasi dalam mewujudkan lingkungan belajar yang aman dan nyaman bagi aktivitas murid dan guru sehingga senantiasa terwujud merdeka belajar.',
    },
    {
      label: 'Opsi 4',
      value: 4,
      deskripsi:
        'Kepala sekolah memastikan dan membangun komunikasi serta interaksi persuasif seluruh warga sekolah dalam berpartisipasi mewujudkan lingkungan sekolah yang kondusif, aman,dan nyaman bagi aktivitas murid dan guru sehingga senantiasa terwujud merdeka belajar.',
    },
    {
      label: 'Opsi 5',
      value: 5,
      deskripsi:
        'Kepala sekolah mengembangkan sistem yang memastikan masukan dan aspirasi murid sebagai pertimbangan dalam penyusunan kebijakan dan praktik belajar pada level kelas dan sekolah dengan dukungan dari warga sekolah yang lain untuk mewujudkan lingkungan belajar yang kondusif, aman, dan nyaman bagi aktivitas murid dan guru sehingga senantiasa terwujud merdeka belajar.',
    },
  ],
  99: [
    {
      label: 'Opsi 1',
      value: 1,
      deskripsi: 'Kepala sekolah mulai memetakan peran orang tua/wali murid dan masyarakat dalam pengembangan sekolah.',
    },
    {
      label: 'Opsi 2',
      value: 2,
      deskripsi:
        'Kepala sekolah mengomunikasikan dan meminta masukan dari orang tua/wali murid dan masyarakat terkait dampak hasil pengembangan sekolah pada peningkatan kualitas belajar murid.',
    },
    {
      label: 'Opsi 3',
      value: 3,
      deskripsi:
        'Kepala sekolah mengomunikasikan dengan menggunakan berbagai strategi komunikasi yang mendorong keterlibatan orang tua/wali murid dan masyarakat dalam pengembangan sekolah yang berdampak pada peningkatan kualitas belajar murid.',
    },
    {
      label: 'Opsi 4',
      value: 4,
      deskripsi:
        'Kepala sekolah mengomunikasilkan hasil  pengembangan sekolah serta menyediakan kesempatan bagi orang tua/wali murid dan masyarakat untuk mengambil peran dalam program pengembangan sekolah yang berdampak pada peningkatan kualitas belajar murid.',
    },
    {
      label: 'Opsi 5',
      value: 5,
      deskripsi:
        'Kepala sekolah membangun mekanisme yang memfasilitasi komunikasi hasil pengembangan sekolah dan penyediaan kesempatan bagi orang tua/wali murid dan masyarakat untuk mengambil peran dalam program pengembangan sekolah yang berdampak pada peningkatan kualitas belajar murid.',
    },
  ],
  100: [
    {
      label: 'Opsi 1',
      value: 1,
      deskripsi:
        'Kepala sekolah memahami bahwa penting  mengikuti kegiatan  jejaring dan organisasi profesi untuk mengembangkan karier. ',
    },
    {
      label: 'Opsi 2',
      value: 2,
      deskripsi: 'Kepala sekolah mengikuti kegiatan  jejaring dan organisasi profesi untuk mengembangkan karier ',
    },
    {
      label: 'Opsi 3',
      value: 3,
      deskripsi:
        'Kepala sekolah secara aktif kegiatan jejaring dan organisasi profesi untuk mengeksplorasi beragam pengalaman belajar yang relevan dengan kebutuhan belajar untuk mengembangkan karier',
    },
    {
      label: 'Opsi 4',
      value: 4,
      deskripsi:
        'Kepala sekolah membuat karya dan/atau memberikan layanan yang bermakna, berbagi praktik baik pembelajaran, dan mengambil beragam peran pada kegiatan jejaring dan organisasi profesi yang relevan dengan kebutuhan belajar untuk mengembangkan karier',
    },
    {
      label: 'Opsi 5',
      value: 5,
      deskripsi:
        'Kepala sekolah guru lain dalam membuat karya dan/atau memberikan layanan yang bermakna, dalam berbagi praktik baik pembelajaran, dan dalam mengambil beragam peran pada kegiatan jejaring dan organisasi profesi yang relevan dengan kebutuhan belajar untuk mengembangkan karier',
    },
  ],
  101: [
    {
      label: 'Opsi 1',
      value: 1,
      deskripsi:
        'Kepala sekolah memahami pentingnya pengelolaan emosi, menggunakan prinsip moral, dan menunjukkan keyakinan terhadap Tuhan yang Maha Esa dalam berperilaku kerja yang mengacu pada kode etik.',
    },
    {
      label: 'Opsi 2',
      value: 2,
      deskripsi:
        'Kepala sekolah mengelola emosi, menggunakan prinsip moral, dan menunjukkan keyakinan terhadap Tuhan yang Maha Esa untuk berperilaku kerja yang mengacu pada kode etik.',
    },
    {
      label: 'Opsi 3',
      value: 3,
      deskripsi:
        'Kepala sekolah mengelola emosi, menggunakan prinsip moral, dan menunjukkan keyakinan terhadap Tuhan yang Maha Esa untuk mengembangkan perilaku kerja dan pembelajaran yang mengacu pada kode etik.',
    },
    {
      label: 'Opsi 4',
      value: 4,
      deskripsi:
        'Kepala sekolah mengelola emosi, menggunakan prinsip moral, dan menunjukkan keyakinan terhadap Tuhan yang Maha Esa untuk mengembangkan perilaku kerja dan pembelajaran yang mengacu pada kode etik, serta mengantisipasi pelanggaran kode etik dan menghindari konflik kepentingan.',
    },
    {
      label: 'Opsi 5',
      value: 5,
      deskripsi:
        'Kepala sekolah membantu kepemimpinan sekolah yang lain dalam mengelola emosi, menggunakan prinsip moral, dan menunjukkan keyakinan terhadap Tuhan yang Maha Esa untuk mengembangkan perilaku kerja dan pembelajaran yang mengacu pada kode etik serta mengantisipasi terjadinya pelanggaran kode etik dan menghindari konflik kepentingan.',
    },
  ],
  102: [
    {
      label: 'Opsi 1',
      value: 1,
      deskripsi: 'Kepala sekolah belum memulai komunitas praktisi di dalam satuan pendidikan',
    },
    {
      label: 'Opsi 2',
      value: 2,
      deskripsi:
        'Kepala sekolah memulai komunitas praktisi di dalam satuan pendidikan dengan memperkenalkan dan membentuk komunitas praktisi',
    },
    {
      label: 'Opsi 3',
      value: 3,
      deskripsi: 'Kepala sekolah menjadikan komunitas praktisi sebagai agenda rutin di satuan pendidikan',
    },
    {
      label: 'Opsi 4',
      value: 4,
      deskripsi: 'Kepala sekolah mulai bergerak menyebarluaskan pengetahuan dan praktik baik ke satuan pendidikan lain',
    },
  ],
};
